module.exports = __webpack_public_path__ + "img/点赞按钮3@2x.45025b89.png";